/* script */

import ApplicationState from 'g3w-state';
import GUI              from 'g3w-app';

const HIGH_CONTRAST_COLORS = {
  skin_color:   '#212c31',
  skin_primary: '#0056b3',
};

const __vue_script__ = {

  name: 'modal-accessibility',

  data() {
    const css = getComputedStyle(document.body);
    const storedSidebarPreference = window.localStorage.getItem('map:preferences:sidebar_open');
    const storedMotionPreference = window.localStorage.getItem('map:accessibility:reduced_motion');
    const default_sidebar_open = !document.body.classList.contains('sidebar-collapse');
    let sidebar_open_at_startup = default_sidebar_open;
    let reduced_motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (null !== storedSidebarPreference) {
      sidebar_open_at_startup = 'true' === storedSidebarPreference;
    }
    if (null !== storedMotionPreference) {
      reduced_motion = 'true' === storedMotionPreference;
    }

    return {
      ApplicationState,
      is_localhost: 'localhost' === window.location.hostname,
      skin_color: window.localStorage.getItem('map:preferences:skin_color') || css.getPropertyValue('--skin-color').trim() || '#95ad36',
      skin_primary: window.localStorage.getItem('map:preferences:skin_primary') || css.getPropertyValue('--skin-primary').trim() || '#4091bf',
      default_sidebar_open,
      sidebar_open_at_startup,
      high_contrast: 'true' === window.localStorage.getItem('map:accessibility:high_contrast'),
      reduced_motion,
    };
  },

  computed: {

    theme_color() {
      if (this.high_contrast) {
        return HIGH_CONTRAST_COLORS.skin_color;
      }
      return this.skin_color;
    },

    primary_color() {
      if (this.high_contrast) {
        return HIGH_CONTRAST_COLORS.skin_primary;
      }
      return this.skin_primary;
    },

  },

  mounted() {
    if (window.localStorage.getItem('map:preferences:skin_color')) {
      this.applyColor('--skin-color', this.skin_color);
    }
    if (window.localStorage.getItem('map:preferences:skin_primary')) {
      this.applyColor('--skin-primary', this.skin_primary);
    }
    this.setReducedMotionClass(this.reduced_motion);

    const storedSidebarPreference = window.localStorage.getItem('map:preferences:sidebar_open');
    if ('true' === storedSidebarPreference) {
      GUI.showSidebar();
    }
    if ('false' === storedSidebarPreference) {
      GUI.hideSidebar();
    }

    if (this.high_contrast) {
      this.applyHighContrast(true);
    }
  },

  methods: {

    show() {
      this.$refs.dialog.showModal();
    },

    close() {
      this.$refs.dialog.close();
    },

    resetPreferences() {
      [
        'map:preferences:skin_color',
        'map:preferences:skin_primary',
        'map:preferences:sidebar_open',
        'map:accessibility:high_contrast',
        'map:accessibility:reduced_motion',
      ].forEach(preferenceKey => window.localStorage.removeItem(preferenceKey));

      document.body.style.removeProperty('--skin-color');
      document.body.style.removeProperty('--skin-primary');
      document.querySelector('.navbar')?.style.removeProperty('--skin-color');
      document.querySelector('.navbar')?.style.removeProperty('--skin-primary');

      const css = getComputedStyle(document.body);
      this.skin_color = css.getPropertyValue('--skin-color').trim();
      this.skin_primary = css.getPropertyValue('--skin-primary').trim();
      this.high_contrast = false;
      this.reduced_motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.setReducedMotionClass(this.reduced_motion);
      this.sidebar_open_at_startup = this.default_sidebar_open;

      if (this.default_sidebar_open) {
        GUI.showSidebar();
      }
      if (!this.default_sidebar_open) {
        GUI.hideSidebar();
      }
    },

    setColor(stateKey, cssVariable, color) {
      this.disableHighContrast();
      this[stateKey] = color;
      window.localStorage.setItem(`map:preferences:${stateKey}`, color);
      this.applyColor(cssVariable, color);
    },

    applyColor(cssVariable, color) {
      document.body.style.setProperty(cssVariable, color);
      document.querySelector('.navbar')?.style.setProperty(cssVariable, color);
    },

    setHighContrast(enabled) {
      this.high_contrast = enabled;
      window.localStorage.setItem('map:accessibility:high_contrast', enabled);
      this.applyHighContrast(enabled);
    },

    applyHighContrast(enabled) {
      if (enabled) {
        this.applyColor('--skin-color', HIGH_CONTRAST_COLORS.skin_color);
        this.applyColor('--skin-primary', HIGH_CONTRAST_COLORS.skin_primary);
        return;
      }
      this.applyColor('--skin-color', this.skin_color);
      this.applyColor('--skin-primary', this.skin_primary);
    },

    disableHighContrast() {
      if (!this.high_contrast) {
        return;
      }
      this.setHighContrast(false);
    },

    setSidebarOpenAtStartup(open) {
      this.sidebar_open_at_startup = open;
      window.localStorage.setItem('map:preferences:sidebar_open', open);
    },

    setReducedMotion(reduced) {
      this.reduced_motion = reduced;
      window.localStorage.setItem('map:accessibility:reduced_motion', reduced);
      this.setReducedMotionClass(reduced);
    },

    setReducedMotionClass(reduced) {
      document.body.classList.toggle('reduced-motion', reduced);
    },

  },

};


/* template */
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialog',{ref:"dialog",staticStyle:{"width":"80vw","max-width":"540px"},attrs:{"id":"modal-accessibility","aria-label":_vm.$t('Accessibility')}},[_c('form',{attrs:{"method":"dialog"}},[_c('header',{staticClass:"a11y-header"},[_c('h3',[_vm._v(_vm._s(_vm.$t('Accessibility')))]),_vm._v(" "),_c('button',{staticClass:"a11y-close",attrs:{"type":"button","aria-label":_vm.$t('close')},on:{"click":_vm.close}},[_c('i',{staticClass:"fas fa-times",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('fieldset',{staticClass:"a11y-section"},[_c('legend',{attrs:{"hidden":""}},[_vm._v(_vm._s(_vm.$t('Appearance')))]),_vm._v(" "),_c('label',{staticClass:"a11y-toggle"},[_c('span',[_vm._v(_vm._s(_vm.$t('High contrast')))]),_vm._v(" "),_c('input',{attrs:{"type":"checkbox","disabled":_vm.is_localhost},domProps:{"checked":_vm.high_contrast},on:{"change":function($event){return _vm.setHighContrast($event.target.checked)}}})]),_vm._v(" "),_c('label',{staticClass:"a11y-row"},[_c('span',[_vm._v(_vm._s(_vm.$t('Theme color')))]),_vm._v(" "),_c('input',{attrs:{"type":"color"},domProps:{"value":_vm.theme_color},on:{"input":function($event){return _vm.setColor('skin_color', '--skin-color', $event.target.value)}}})]),_vm._v(" "),_c('label',{staticClass:"a11y-row"},[_c('span',[_vm._v(_vm._s(_vm.$t('Primary color')))]),_vm._v(" "),_c('input',{attrs:{"type":"color"},domProps:{"value":_vm.primary_color},on:{"input":function($event){return _vm.setColor('skin_primary', '--skin-primary', $event.target.value)}}})]),_vm._v(" "),_c('label',{staticClass:"a11y-toggle"},[_c('span',[_vm._v(_vm._s(_vm.$t('Reduce animations')))]),_vm._v(" "),_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.reduced_motion},on:{"change":function($event){return _vm.setReducedMotion($event.target.checked)}}})]),_vm._v(" "),_c('label',{staticClass:"a11y-toggle"},[_c('span',[_vm._v(_vm._s(_vm.$t('Open sidebar on startup')))]),_vm._v(" "),_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.sidebar_open_at_startup},on:{"change":function($event){return _vm.setSidebarOpenAtStartup($event.target.checked)}}})])]),_vm._v(" "),_c('menu',{staticClass:"a11y-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":_vm.resetPreferences}},[_vm._v(_vm._s(_vm.$t('Restore defaults')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t('close')))])])])])
}
var staticRenderFns = []

const __vue_render__ = render;
const __vue_staticRenderFns__ = staticRenderFns;

const __vue_component__ = __vue_script__;
__vue_component__.render = __vue_render__;
__vue_component__.staticRenderFns = __vue_staticRenderFns__;
__vue_component__._compiled = true;
__vue_component__.__file = "/home/volterra79/G3W-SUITE/g3w-client/src/components/ModalAccessibility.vue";
__vue_component__._scopeId = "data-v-059c97a0";
/* style inject */
import __vue_create_injector__ from 'g3w-vue:style-injector';
[{"id":"059c97a0-0","css":"dialog[data-v-059c97a0]{border:0;border-radius:3px;padding:18px}.a11y-header[data-v-059c97a0]{display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid #ddd}.a11y-header h3[data-v-059c97a0]{margin:0;font-size:1.3em;font-weight:700}.a11y-close[data-v-059c97a0]{width:32px;height:32px;border:0;background:transparent;color:inherit}.a11y-section[data-v-059c97a0]{padding:14px 0;border-bottom:1px solid #ddd}.a11y-section legend[data-v-059c97a0]{margin:0 0 10px;border:0;font-size:1.05em;font-weight:700}.a11y-row[data-v-059c97a0],.a11y-toggle[data-v-059c97a0]{display:flex;align-items:center;justify-content:space-between;gap:16px;width:100%;margin:0;font-weight:400}.a11y-section>label+label[data-v-059c97a0]{margin-top:12px}.a11y-row input[type=color][data-v-059c97a0]{width:44px;height:32px;padding:2px;border:1px solid #999;cursor:pointer}.a11y-toggle input[data-v-059c97a0]{flex:0 0 auto}.a11y-footer[data-v-059c97a0]{display:flex;justify-content:space-between;margin:14px 0 0;padding:0}\n","media":"","filename":"src/components/ModalAccessibility.vue"},{"id":"059c97a0-1","css":"body.reduced-motion *,body.reduced-motion *:before,body.reduced-motion *:after{animation:none!important;scroll-behavior:auto!important;transition:none!important}\n","media":"","filename":"src/components/ModalAccessibility.vue"}].forEach(__vue_create_injector__());
export default __vue_component__;